import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSubcategories } from 'api/repository/categories.api';

export const fetchSubcategoriesAsync = createAsyncThunk(
  'subcategories/fetchSubcategories',
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await fetchSubcategories(categoryId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const subcategoriesSlice = createSlice({
  name: 'subcategories',
  initialState: {
    items: [], 
    loading: false,
    error: null,
    currentCategoryId: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubcategoriesAsync.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.items = []; 
        state.currentCategoryId = action.meta.arg;
      })
      .addCase(fetchSubcategoriesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload || [];
      })
      .addCase(fetchSubcategoriesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.items = []; 
      });
  },
});

export default subcategoriesSlice.reducer;
